import { render, staticRenderFns } from "./UserHeader.vue?vue&type=template&id=b63e7750&scoped=true&"
import script from "./UserHeader.vue?vue&type=script&lang=js&"
export * from "./UserHeader.vue?vue&type=script&lang=js&"
import style0 from "@/sass/08_modules/user-header.scss?vue&type=style&index=0&id=b63e7750&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b63e7750",
  null
  
)

export default component.exports